import {Model} from 'vue-mc';
import Vue from "vue";
import http from "../httpMiddleware/http";

Model.prototype.$http = http;
export default class transitionLetterModel extends Model {

	defaults() {
		return {
			inBuiltApi: Vue.prototype.$interpretersApiUrl,
			methodTypes: 'getLetter',
			data: {},
			dbData: {
				content: ''
			}
		}
	}

	options() {
		return {
			methods: {
				getLetter: 'GET',
				sendEmail: 'GET'
			}
		}
	}

	routes() {
		return {
			getLetter: 'interpreter/confirm_revalidation_letter',
			sendEmail: 'interpreter/revalidation_letter'
		}
	}

	requestRoute() {
		let headers = {
			Bearer: localStorage.getItem('jwt')
		};
		let method = this.getOption('methods.' + this.methodTypes);
		let route = this.inBuiltApi + this.getRoute(this.methodTypes);
		let params = this.getRouteParameters();
		let url = this.getURL(route, params);
		let data = this.data;

		// console.log(headers, method, url, data);

		return this.getRequest({headers, method, url, data}).send();
	}

	getLetterContent() {
		return this.requestRoute();
	}

	sendLetter() {
		this.methodTypes = 'sendEmail';
		return this.requestRoute();
	}
}
